import Layers from "../../../../../../../src/layers/Layers";
import { eventBus, EnumEventBus } from "../../EventBus";
import PivotPoint from "../../../entities/PivotPoint";
import Shape from "../../../entities/Shape";
import { Coord } from "../../../../../../../src/types/Interface";
import { QuestionType, ShapeColor } from "../../../types/Enum";
import { ShapeManagerDrawProps } from "../../../types/Interface";


export default class ShapeManager {
  private Layers = Layers.getInstance();
  private shape = this.Layers.Top.addChild(new Shape("A", ShapeColor.black));
  private rotatedShape = this.Layers.Top.addChild(new Shape("B", ShapeColor.red));
  private pivotPoint = this.Layers.Top.addChild(new PivotPoint());
  private rotatedShapeCoords!: Coord[];
  private rotatedCenterCoord!: Coord;
  private qType: QuestionType;
  private pivotCoord: Coord;
  private rotation: number;
  private origin: Coord;

  constructor() {
    eventBus.on(EnumEventBus.setShowSolution, (v: boolean) => this.handleSolution(v))
  }

  handleSolution(v: boolean) {
    if (!v) {
      return this.qType == QuestionType.TYPE1 ? this.rotatedShape.clearAll() : this.pivotPoint.clear();
    }
    if (this.qType == QuestionType.TYPE1) {
      this.rotatedShape.setShapeLabelRot(this.rotation);
      return this.rotatedShape.draw(this.rotatedShapeCoords, this.rotatedCenterCoord, this.qType);
    }
    this.drawPoint(ShapeColor.red);
  }

  draw({ shapeCoords, rotatedShapeCoords, centerCoord, rotatedCenterCoord, pivotCoord, rotation, qType, origin }: ShapeManagerDrawProps) {
    this.rotatedShapeCoords = rotatedShapeCoords;
    this.rotatedCenterCoord = rotatedCenterCoord;
    this.pivotCoord = pivotCoord;
    this.rotation = rotation;
    this.qType = qType;
    this.origin = origin;

    this.clearAll();

    this.rotatedShape.parent.removeChild(this.rotatedShape);
    this.pivotPoint.parent.removeChild(this.pivotPoint);
    if (qType === QuestionType.TYPE1) {
      this.Layers.UI.addChild(this.rotatedShape);
      this.Layers.Top.addChild(this.pivotPoint);

      this.shape.draw(shapeCoords, centerCoord, qType);
      return this.drawPoint(ShapeColor.black);
    }
    this.Layers.Top.addChild(this.rotatedShape);
    this.Layers.UI.addChild(this.pivotPoint);

    this.shape.draw(shapeCoords, centerCoord, qType);
    this.rotatedShape.setShapeLabelRot(this.rotation);
    this.rotatedShape.draw(rotatedShapeCoords, rotatedCenterCoord, qType);
  }
  clearAll() {
    this.shape.clearAll();
    this.rotatedShape.clearAll();
    this.pivotPoint.clear();
  }
  drawPoint(color: ShapeColor) {
    this.pivotPoint.setColor(color);
    this.pivotPoint.drawPoint(this.pivotCoord, this.origin, this.qType);
  }
}